import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import SelectInput from "../../widgets/SelectInput";

import { GetRecuperi } from "../../services/recuperiService";
import getCorsi from "../../services/getCorsi";
import getMaterie from "../../services/getMaterie";
import getCategorieCorsi from "../../services/getCategorieCorsi";
import getInsegnanti from "../../services/getInsegnanti";
import getStudenti from "../../services/getStudenti";
import getLezioneRecuperata from "../../services/getLezioneRecuperata";

export default class Recuperi extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.pageTitle = props.pageTitle || "Recuperi";
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.state = {
      isLoading: false,
      recuperi: [],
      recuperiFiltrati: [], // Aggiungiamo questo per i filtri
      corsi: [],
      materie: [],
      insegnanti: [],
      studenti: [],
      categorieCorsi: [],
      selectedCategoria: null,
      selectedCorso: null,
      selectedMateria: null,
      selectedStato: null,
      dataInizio: "",
      dataFine: "",
      optionsCategoria: [],
      optionsCorso: [],
      optionsMateria: [],
      optionsStato: [],
    };

    this.handleCategoriaChange = this.handleCategoriaChange.bind(this);
    this.handleCorsoChange = this.handleCorsoChange.bind(this);
    this.handleMateriaChange = this.handleMateriaChange.bind(this);
    this.handleStatoChange = this.handleStatoChange.bind(this);
  }

  handleCategoriaChange(option) {
    this.setState({ selectedCategoria: option }, () => {
      this.applicaFiltri();
    });
  }

  handleCorsoChange(option) {
    this.setState({ selectedCorso: option }, () => {
      this.applicaFiltri();
    });
  }

  handleMateriaChange(option) {
    this.setState({ selectedMateria: option }, () => {
      this.applicaFiltri();
    });
  }

  handleStatoChange(option) {
    this.setState({ selectedStato: option }, () => {
      this.applicaFiltri();
    });
  }

  handleDataInizioChange = (event) => {
    this.setState({ dataInizio: event.target.value }, () => {
      this.applicaFiltri();
    });
  };

  handleDataFineChange = (event) => {
    this.setState({ dataFine: event.target.value }, () => {
      this.applicaFiltri();
    });
  };

  applicaFiltri = () => {
    const {
      selectedCategoria,
      selectedCorso,
      selectedMateria,
      selectedStato,
      dataInizio,
      dataFine,
      recuperi,
    } = this.state;
    let recuperiFiltrati = [...recuperi];

    // Filtro per corso
    if (selectedCorso) {
      recuperiFiltrati = recuperiFiltrati.filter(
        (recupero) => recupero.corso_nome === selectedCorso.label
      );
    }

    // Filtro per materia
    if (selectedMateria) {
      recuperiFiltrati = recuperiFiltrati.filter(
        (recupero) => recupero.materia_nome === selectedMateria.label
      );
    }

    // Filtro per categoria (basato sul corso)
    if (selectedCategoria) {
      recuperiFiltrati = recuperiFiltrati.filter((recupero) => {
        // Cerca nella lista corsi la categoria del corso del recupero
        const corso = this.corsi.find((c) => c.name === recupero.corso_nome);
        return corso && corso.id_categoria === selectedCategoria.value;
      });
    }

    // Filtro per data inizio
    if (dataInizio) {
      recuperiFiltrati = recuperiFiltrati.filter((recupero) => {
        return recupero.data_recupero && recupero.data_recupero >= dataInizio;
      });
    }

    // Filtro per data fine
    if (dataFine) {
      recuperiFiltrati = recuperiFiltrati.filter((recupero) => {
        return recupero.data_recupero && recupero.data_recupero <= dataFine;
      });
    }

    // Filtro per stato
    if (selectedStato) {
      recuperiFiltrati = recuperiFiltrati.filter((recupero) => {
        return recupero.stato === selectedStato.value;
      });
    }

    this.setState({ recuperiFiltrati });
  };

  async reload() {
    this.setState({ isLoading: true });

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    try {
      // Carica tutti i dati necessari
      const recuperiData = await GetRecuperi(username, token);
      this.recuperi = Array.isArray(recuperiData) ? recuperiData : [];

      this.corsi = (await getCorsi(username, token)) || [];
      this.materie = (await getMaterie(username, token)) || [];
      this.insegnanti = (await getInsegnanti(username, token)) || [];
      this.studenti = (await getStudenti(username, token)) || [];
      this.categorieCorsi = (await getCategorieCorsi(username, token)) || [];

      console.log("Dati recuperi caricati:", this.recuperi);
      console.log(
        "Tipo dati recuperi:",
        typeof this.recuperi,
        Array.isArray(this.recuperi)
      );

      // ✅ FIX: Usa direttamente lo stato dal backend (getRecuperi.php) invece di ricontrollare
      // Il backend già calcola correttamente lo stato considerando id_sessione e proposte
      const recuperiConStatoVerificato = this.recuperi.map((recupero) => {
        // Usa lo stato dal backend, che già considera:
        // - stato_proposta (0 = programmato, 1 = completato, 2 = annullato)
        // - id_sessione corretto (dalla proposta o dalla richiesta)
        // - presenza di id_lezione_recupero per verificare il completamento

        let statoEffettivo = recupero.stato || "programmato";

        console.log(
          `[Recuperi] ID ${recupero.id} (richiesta ${recupero.id_richiesta_recupero}): ` +
            `stato backend="${recupero.stato}", ` +
            `id_sessione=${recupero.id_sessione}, ` +
            `id_lezione_recupero=${recupero.id_lezione_recupero} ` +
            `→ stato finale="${statoEffettivo}"`
        );

        return {
          ...recupero,
          stato: statoEffettivo,
        };
      });

      // I dati dall'API sono già completi, li mappiamo solo per la visualizzazione
      const recuperiArricchiti = recuperiConStatoVerificato.map((recupero) => {
        return {
          ...recupero,
          // Usa i dati già presenti dall'API
          nomeCorso: recupero.corso_nome || "N/A",
          nomeMateria: recupero.materia_nome || "N/A",
          nomeInsegnante: recupero.insegnante_nome || "N/A",
          nomeStudente:
            recupero.studente_nome && recupero.studente_cognome
              ? `${recupero.studente_nome} ${recupero.studente_cognome}`
              : "N/A",
          dataFormatted: recupero.data_recupero
            ? new Date(recupero.data_recupero).toLocaleDateString("it-IT")
            : "N/A",
          oraFormatted:
            recupero.ora_inizio && recupero.ora_fine
              ? `${recupero.ora_inizio.slice(0, 5)} - ${recupero.ora_fine.slice(
                  0,
                  5
                )}`
              : "N/A",
          aulaFormatted: recupero.aula || "N/A",
          noteFormatted: recupero.note || "N/A", // Aggiungo il campo note formattato
          statoFormatted: recupero.stato || "N/A", // Ora usa lo stato verificato
        };
      });

      // FILTRO DUPLICATI: Se un recupero è "completato", rimuovi quelli "programmati" per lo stesso studente/materia/data/sessione
      // IMPORTANTE: Deve considerare anche id_sessione per non rimuovere le mezze giornate!
      const recuperiFiltrati = recuperiArricchiti.filter((recupero) => {
        // Se questo recupero è "programmato", verifica se esiste uno "completato" per lo stesso studente/materia/data/sessione
        if (recupero.stato === "programmato") {
          const esisteCompletato = recuperiArricchiti.some(
            (r) =>
              r.stato === "completato" &&
              r.id_studente === recupero.id_studente &&
              r.corso_nome === recupero.corso_nome &&
              r.materia_nome === recupero.materia_nome &&
              r.data_recupero === recupero.data_recupero &&
              // ✅ Confronta anche id_sessione: solo se sono IDENTICI (stessa mezza giornata) rimuovi
              r.id_sessione === recupero.id_sessione
          );

          // Se esiste un completato PER LA STESSA SESSIONE, escludi questo programmato
          if (esisteCompletato) {
            console.log(
              `[FILTRO DUPLICATI] Rimosso recupero programmato ID ${recupero.id} perché esiste uno completato per ${recupero.nomeStudente} - ${recupero.materia_nome} (sessione ${recupero.id_sessione})`
            );
            return false;
          }
        }

        return true; // Mantieni tutti gli altri
      });

      // Prepara le opzioni per i filtri basandoci sui dati unici dei recuperi
      const corsiUnici = [
        ...new Set(
          recuperiFiltrati
            .map((r) => r.corso_nome)
            .filter((nome) => nome && nome !== "N/A")
        ),
      ];

      const materieUniche = [
        ...new Set(
          recuperiFiltrati
            .map((r) => r.materia_nome)
            .filter((nome) => nome && nome !== "N/A")
        ),
      ];

      const optionsCorso = corsiUnici.map((nomeCorso, index) => ({
        value: index,
        label: nomeCorso,
      }));

      const optionsMateria = materieUniche.map((nomeMateria, index) => ({
        value: index,
        label: nomeMateria,
      }));

      // Manteniamo le categorie dal servizio esistente per ora
      const optionsCategoria = this.categorieCorsi.map((categoria) => ({
        value: categoria.id,
        label: categoria.name,
      }));

      // Prepara le opzioni per il filtro stato
      const statiUnici = [
        ...new Set(
          recuperiFiltrati
            .map((r) => r.stato)
            .filter((stato) => stato && stato !== "N/A")
        ),
      ];

      const optionsStato = statiUnici.map((stato) => ({
        value: stato,
        label: stato.charAt(0).toUpperCase() + stato.slice(1), // Capitalizza la prima lettera
      }));

      this.setState({
        recuperi: recuperiFiltrati,
        recuperiFiltrati: recuperiFiltrati, // Mostra tutti i risultati di default
        corsi: this.corsi,
        materie: this.materie,
        insegnanti: this.insegnanti,
        studenti: this.studenti,
        categorieCorsi: this.categorieCorsi,
        optionsCategoria: optionsCategoria,
        optionsCorso: optionsCorso,
        optionsMateria: optionsMateria,
        optionsStato: optionsStato,
      });
    } catch (error) {
      console.error("Errore nel caricamento dei dati:", error);
      alert("Errore nel caricamento dei dati. Controllare la connessione.");
    } finally {
      this.setState({ isLoading: false });
    }
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {
    var headCells = [
      {
        id: "dataFormatted",
        numeric: false,
        disablePadding: true,
        label: "Data",
      },
      {
        id: "oraFormatted",
        numeric: false,
        disablePadding: false,
        label: "Ora",
      },
      {
        id: "nomeStudente",
        numeric: false,
        disablePadding: false,
        label: "Studente",
      },
      {
        id: "nomeCorso",
        numeric: false,
        disablePadding: false,
        label: "Corso",
      },
      {
        id: "nomeMateria",
        numeric: false,
        disablePadding: false,
        label: "Materia",
      },
      {
        id: "noteFormatted",
        numeric: false,
        disablePadding: false,
        label: "Note",
      },
      {
        id: "nomeInsegnante",
        numeric: false,
        disablePadding: false,
        label: "Insegnante",
      },
      {
        id: "aulaFormatted",
        numeric: false,
        disablePadding: false,
        label: "Aula",
      },
      {
        id: "statoFormatted",
        numeric: false,
        disablePadding: false,
        label: "Stato",
      },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    const recuperi = this.state.recuperiFiltrati || [];

    this.searchCols = [
      "studente_nome",
      "studente_cognome",
      "corso_nome",
      "materia_nome",
      "insegnante_nome",
      "stato",
      "aula",
      "note", // Aggiungo le note alla ricerca
      "dataFormatted", // Aggiungo la data alla ricerca (formato DD/MM/YYYY)
      "data_recupero", // Aggiungo anche il formato grezzo della data (YYYY-MM-DD)
    ];

    const cookies = new Cookies();

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Caricamento recuperi..."}
        >
          <PageTitle title={this.pageTitle} />

          {/* Sezione Filtri */}
          <div
            style={{
              background: "white",
              padding: "20px",
              marginBottom: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <h4
              style={{
                marginBottom: "25px",
                color: "#333",
                fontSize: "18px",
                fontWeight: "600",
                borderBottom: "2px solid #a00008",
                paddingBottom: "8px",
              }}
            >
              Filtri di Ricerca
            </h4>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "15px",
                marginBottom: "15px",
              }}
            >
              {/* Filtro per Categoria */}
              <div>
                <SelectInput
                  label="Categoria"
                  name="categoria"
                  options={this.state.optionsCategoria}
                  value={this.state.selectedCategoria}
                  onChange={this.handleCategoriaChange}
                  placeholder="Seleziona categoria..."
                />
              </div>

              {/* Filtro per Corso */}
              <div>
                <SelectInput
                  label="Corso"
                  name="corso"
                  options={this.state.optionsCorso}
                  value={this.state.selectedCorso}
                  onChange={this.handleCorsoChange}
                  placeholder="Seleziona corso..."
                />
              </div>

              {/* Filtro per Materia */}
              <div>
                <SelectInput
                  label="Materia"
                  name="materia"
                  options={this.state.optionsMateria}
                  value={this.state.selectedMateria}
                  onChange={this.handleMateriaChange}
                  placeholder="Seleziona materia..."
                />
              </div>

              {/* Filtro per Stato */}
              <div>
                <SelectInput
                  label="Stato"
                  name="stato"
                  options={this.state.optionsStato}
                  value={this.state.selectedStato}
                  onChange={this.handleStatoChange}
                  placeholder="Seleziona stato..."
                />
              </div>
            </div>

            {/* Riga separata per i filtri data e pulsante reset */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "15px",
                alignItems: "flex-end",
              }}
            >
              {/* Filtro Data Inizio */}
              <div style={{ minWidth: "150px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#333",
                    marginBottom: "8px",
                  }}
                >
                  Data da:
                </label>
                <input
                  type="date"
                  value={this.state.dataInizio}
                  onChange={this.handleDataInizioChange}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "14px",
                  }}
                />
              </div>

              {/* Filtro Data Fine */}
              <div style={{ minWidth: "150px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#333",
                    marginBottom: "8px",
                  }}
                >
                  Data a:
                </label>
                <input
                  type="date"
                  value={this.state.dataFine}
                  onChange={this.handleDataFineChange}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "14px",
                  }}
                />
              </div>

              {/* Pulsante Reset Filtri */}
              <div>
                <button
                  onClick={() => {
                    this.setState({
                      selectedCategoria: null,
                      selectedCorso: null,
                      selectedMateria: null,
                      selectedStato: null,
                      dataInizio: "",
                      dataFine: "",
                      recuperiFiltrati: this.state.recuperi,
                    });
                  }}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#a00008",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                    height: "38px",
                  }}
                >
                  Reset Filtri
                </button>
              </div>
            </div>
          </div>

          {/* Sezione Filtri Attivi */}
          {(this.state.selectedCategoria ||
            this.state.selectedCorso ||
            this.state.selectedMateria ||
            this.state.selectedStato ||
            this.state.dataInizio ||
            this.state.dataFine) && (
            <div
              style={{
                background: "#f8f9fa",
                padding: "15px",
                marginBottom: "20px",
                borderRadius: "8px",
                border: "1px solid #e9ecef",
              }}
            >
              <div
                style={{
                  marginBottom: "10px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#495057",
                }}
              >
                Filtri attivi:
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {this.state.selectedCategoria && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#a00008",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      gap: "5px",
                    }}
                  >
                    <span>Categoria: {this.state.selectedCategoria.label}</span>
                    <button
                      onClick={() => {
                        this.setState({ selectedCategoria: null }, () => {
                          this.applicaFiltri();
                        });
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "white",
                        cursor: "pointer",
                        fontSize: "14px",
                        padding: "0",
                        marginLeft: "2px",
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}
                {this.state.selectedCorso && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#a00008",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      gap: "5px",
                    }}
                  >
                    <span>Corso: {this.state.selectedCorso.label}</span>
                    <button
                      onClick={() => {
                        this.setState({ selectedCorso: null }, () => {
                          this.applicaFiltri();
                        });
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "white",
                        cursor: "pointer",
                        fontSize: "14px",
                        padding: "0",
                        marginLeft: "2px",
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}
                {this.state.selectedMateria && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#a00008",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      gap: "5px",
                    }}
                  >
                    <span>Materia: {this.state.selectedMateria.label}</span>
                    <button
                      onClick={() => {
                        this.setState({ selectedMateria: null }, () => {
                          this.applicaFiltri();
                        });
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "white",
                        cursor: "pointer",
                        fontSize: "14px",
                        padding: "0",
                        marginLeft: "2px",
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}
                {this.state.selectedStato && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#a00008",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      gap: "5px",
                    }}
                  >
                    <span>Stato: {this.state.selectedStato.label}</span>
                    <button
                      onClick={() => {
                        this.setState({ selectedStato: null }, () => {
                          this.applicaFiltri();
                        });
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "white",
                        cursor: "pointer",
                        fontSize: "14px",
                        padding: "0",
                        marginLeft: "2px",
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}
                {this.state.dataInizio && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#a00008",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      gap: "5px",
                    }}
                  >
                    <span>Da: {this.state.dataInizio}</span>
                    <button
                      onClick={() => {
                        this.setState({ dataInizio: "" }, () => {
                          this.applicaFiltri();
                        });
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "white",
                        cursor: "pointer",
                        fontSize: "14px",
                        padding: "0",
                        marginLeft: "2px",
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}
                {this.state.dataFine && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#a00008",
                      color: "white",
                      padding: "4px 8px",
                      borderRadius: "16px",
                      fontSize: "12px",
                      gap: "5px",
                    }}
                  >
                    <span>A: {this.state.dataFine}</span>
                    <button
                      onClick={() => {
                        this.setState({ dataFine: "" }, () => {
                          this.applicaFiltri();
                        });
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "white",
                        cursor: "pointer",
                        fontSize: "14px",
                        padding: "0",
                        marginLeft: "2px",
                      }}
                    >
                      ×
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          <Table
            key={`table-${recuperi.length}`}
            headCells={headCells}
            searchCols={this.searchCols}
            pdf={false}
            excel={false}
            mail={false}
            phone={false}
            rows={recuperi}
          />
        </LoadingOverlay>
      </>
    );
  }
}
